/*globals jQuery, tabSet */
( function() {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	window.MSR.responsive = ( function( $, undefined ) {
		/******* RESPONSIVE SCRIPTS *******/

		var checkSupportedScripts = function() {
			if ( $.winSize < 3 ) {
				mobileScripts();
			} else {
				desktopScripts();
			}
		};

		var desktopScripts = function() {

			if ( typeof $.blogTabs !== 'undefined' && $.blogTabs !== null ) {
				//destroy tabs
				$.blogTabs.destroy();
			}

		};

		var mobileScripts = function() {

			if ( typeof $.blogTabs === 'undefined' || $.blogTabs === null ) {
				$.blogTabs = tabSet( '.c-tabs--blogs' );
			} else {
				//rebuild tabs
				$.blogTabs.build();
			}

		};

		return {
			checkSupportedScripts: checkSupportedScripts,
			desktopScripts: desktopScripts,
			mobileScripts: mobileScripts
		};
	} )( jQuery );

} )();
